<template>
  <header
    class="fixed top-4 left-1/2 -translate-x-1/2 z-50 w-[90%] md:w-[70%] bg-white rounded-full shadow flex items-center justify-between px-6 py-2">
    <div class="flex items-center gap-4">
      <router-link to="/">
        <img src="@/assets/logo1.png" alt="Logo OverX" class="h-6 w-auto cursor-pointer" />
      </router-link>
    </div>
    <nav class="hidden md:flex flex-wrap justify-center items-center space-x-6">
      <span @click="navigate('#home')"
        class="text-gray-900 font-semibold cursor-pointer hover:text-orange-500">Home</span>
      <span @click="navigate('#funcionalidades')"
        class="text-gray-500 cursor-pointer hover:text-orange-500">Funcionalidades</span>
      <router-link to="/quemsomos" class="text-gray-500 cursor-pointer hover:text-orange-500">Sobre Nós</router-link>
      <span @click="navigate('#informacoes')"
        class="text-gray-500 cursor-pointer hover:text-orange-500">Informações</span>
    </nav>

 

    <div class="hidden md:flex items-center space-x-4">
       <!-- modal -->
       <button
        @click="showJaSouClienteModal = true"
        class="bg-orange-500 text-white text-center px-4 py-2 rounded-lg cursor-pointer">
        Já sou cliente
      </button>
      <a
        :href="whatsappLink"
        target="_blank"
        class="bg-orange-500 text-white text-center px-4 py-2 rounded-lg cursor-pointer">
        Experimente Gratuitamente
      </a>
    </div>

    <div class="md:hidden flex items-center">
      <button @click="toggleMenu" class="text-gray-900 focus:outline-none">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor"
          stroke-width="2">
          <path stroke-linecap="round" stroke-linejoin="round" d="M4 6h16M4 12h16M4 18h16" />
        </svg>
      </button>
    </div>

    <div v-if="menuOpen"
      class="absolute top-16 left-0 w-full bg-white border-t border-gray-200 shadow-sm rounded-b-xl md:hidden">
      <nav class="flex flex-col space-y-2 p-4">
        <span @click="navigate('#home')"
          class="text-gray-700 hover:text-orange-500 font-medium cursor-pointer">Home</span>
        <span @click="navigate('#funcionalidades')"
          class="text-gray-700 hover:text-orange-500 font-medium cursor-pointer">Funcionalidades</span>
        <router-link
          to="/quemsomos"
          @click="menuOpen = false"
          class="text-gray-700 hover:text-orange-500 font-medium cursor-pointer"
        >
          Sobre Nós
        </router-link>
        <span @click="navigate('#informacoes')"
          class="text-gray-700 hover:text-orange-500 font-medium cursor-pointer">
          Informações
        </span>

        <button
          @click="showJaSouClienteModal = true; menuOpen = false"
          class="bg-orange-500 text-white px-4 py-2 rounded-lg text-center cursor-pointer">
          Já sou cliente
        </button>
        <a
          :href="whatsappLink"
          target="_blank"
          class="bg-orange-500 text-white px-4 py-2 rounded-lg text-center cursor-pointer">
          Experimente Gratuitamente
        </a>

      </nav>
    </div>
  </header>
  <JaSouClienteModal
    :show="showJaSouClienteModal"
    @close="showJaSouClienteModal = false"
  />
</template>

<script>
import { getWhatsAppLink } from '@/utils/whatsapp';
import JaSouClienteModal from '@/components/Cliente/JaSouClienteModal.vue'
export default {

  name: "HeaderPage",
  components: {
    JaSouClienteModal
  },
  data() {
    return {
      menuOpen: false,
      showJaSouClienteModal: false
    };
  },
  computed: {
    whatsappLink() {
      return getWhatsAppLink("Olá! Quero experimentar gratuitamente a OverX.");
    },
  },

  methods: {
    toggleMenu() {
      this.menuOpen = !this.menuOpen;
    },
    navigate(id) {
      this.menuOpen = false;
      const sectionId = id.replace('#', '');
      const sectionSelector = `#${sectionId}`;

      if (this.$route.path === '/') {
        const el = document.querySelector(sectionSelector);
        if (el) el.scrollIntoView({ behavior: 'smooth' });
      } else {
        
        this.$router.push({ path: '/' }).then(() => {
          requestAnimationFrame(() => {
            const el = document.querySelector(sectionSelector);
            if (el) el.scrollIntoView({ behavior: 'smooth' });
          });
        });
      }
    }
  },
};
</script>